import { BloodGlucoseTest } from "../api/apiTypes";
import { BloodGlucoseResult } from "../api/DeviceLinkApi/StatStripXpress2";
import { authenticatedFetchRetry } from "../api/FetchRetry";
import { User } from "oidc-client-ts";

declare var rootUrl: string;

export const uploadTests = async (
    parentSessionId: string,
    tests: BloodGlucoseResult[],
    user: User,
): Promise<BloodGlucoseTest[]> => {

    const mappedTests = tests.map((test, index) => {
        let sampleMethodId;
        switch (test.flags) {
            case 0:
                sampleMethodId = "BGSM_BLOOD";
                break;
            case 1:
                sampleMethodId = "BGSM_CONTROL_1";
                break;
            case 2:
                sampleMethodId = "BGSM_CONTROL_2";
                break;
            case 3:
                sampleMethodId = "BGSM_CONTROL_3";
                break;
        }

        return {
            SessionId: parentSessionId,
            TestDateTime: test.testTime,
            SampleMethodId: sampleMethodId,
            TestNumber: index + 1,
            BloodGlucoseMgdl:
                test.testName === "Glu" && test.unit === "mg/dL" ? test.resultValue : undefined,
            BloodGlucoseMmol:
                test.testName === "Glu" && test.unit === "mmol/L"
                    ? test.resultValue
                    : undefined,
            BloodKetoneMmol: test.testName === "Ket" ? test.resultValue : undefined
        }
    })

    return authenticatedFetchRetry(
        user,
        `${rootUrl}api/BloodGlucoseSessions/${parentSessionId}/BatchUploadTests`,
        {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(mappedTests)
        },
        1,
        60000
    ).then(response => response.json());
};
